import { RISK_SEVERITIES } from '@/stores/mrx';
import { useTrackStore } from '@/stores/track';
import { assessConditions } from '@/utils/mrxEngine';
import { convertedResponses } from '@/utils/panelResponses';
import type { DangerSignFinding, DangerSignObservation } from '../types';

export async function scoreDangerSigns(
  names: string[],
  observations?: DangerSignObservation[],
): Promise<DangerSignFinding[]> {
  if (!names.length) return [];

  const trackStore = useTrackStore();
  const responses = await convertedResponses(trackStore.current, observations);
  if (!responses.length) return [];

  const conditions = names.map(name => ({ type: 'condition', name }));
  const assessments = await assessConditions([...responses, ...trackStore.classifications, ...conditions]);

  return names
    .map(name => {
      const assessment = assessments.find(result => result.name === name);
      if (!assessment) throw new Error(`No danger sign assessment returned for ${name}`);
      return assessment;
    })
    .filter(assessment => RISK_SEVERITIES.includes(assessment.severity))
    .map(({ name, severity, triage_recommendation }) => ({ name, severity, triage_recommendation }));
}
